export default __webpack_public_path__ + "static/Stone-c087baf6e6ef418a95ac95a95091bff8.png";